// src/lib/translator.tsx
import { createContext, useContext, useEffect, useState } from "react";
import enFile from "../utils/languages/en.json";
import esFile from "../utils/languages/es.json";

const TranslatorContext = createContext(undefined);

export const TranslatorProvider = ({ children }) => {
    const [preferredLanguage, setPreferredLanguage] = useState(
        localStorage.getItem("preferredLanguage") || "en"
    );

    useEffect(() => {
        const savedLang = localStorage.getItem("preferredLanguage");

        if (savedLang) {
            setPreferredLanguage(savedLang);
        }
    }, []);

    const updatePreference = (lang) => {
        localStorage.setItem("preferredLanguage", lang);
        setPreferredLanguage(lang);
    };

    const translate = (key, values) => {

        if (!key) key = "empty-key";

        const dots = key.match(/\./g) || [];
        const dotCount = dots.length;

        const symbols = key.match(/!/g) || [];
        const symbolsCount = symbols.length;

        key = key.replace(/\./g, "");
        key = key.replace(/!/g, "");

        const file = preferredLanguage === "en" ? enFile : esFile;
        let text = file[key];

        if (values?.length && text) {
            values.forEach((value) => {
                text = text.replace(`\${${value.key}}`, value.value);
            });
        }

        if (text !== null && text !== undefined && text !== "") {
            text = text + ".".repeat(dotCount);
            text = text + "!".repeat(symbolsCount);
        }

        return text || "missing";
    };

    return (
        <TranslatorContext.Provider
            value={{ preferredLanguage, updatePreference, translate }}
        >
            {children}
        </TranslatorContext.Provider>
    );
};

export const useTranslator = () => {
    const context = useContext(TranslatorContext);
    if (!context) {
        throw new Error("useTranslator must be used within a TranslatorProvider");
    }
    return context;
};
